import { createAction, createReducer } from '@reduxjs/toolkit';
import { RecordingMessage } from '../../../types/rest/assetCatalogTypes';
import { SortConfiguration } from '../../../types/rest/paginationTypes';
import { RecordingMessagesState } from './recordingMessagesTypes';
import { PageFilterContent } from '../../ui/pageFilters/pageFilterTypes';
import { SelectAllType } from '../../../components/blazeTable/BlazeTable.types';

const initialState: RecordingMessagesState = {
  recordingId: 0,
  recordingMessages: [],
  isLoading: false,
  isCreatingNewRecordingMessage: false,
  expandedRecordingMessageId: null,
  sort: { sortKey: 'index', direction: 'asc' } as SortConfiguration,
  pageable: {
    skip: 1,
    limit: 5,
  },
  selectAllType: null,
  selectedRecordingMessages: [],
  totalMessages: 0,
  pageFilter: {
    searchTerm: '',
    serviceId: 0,
  } as PageFilterContent,
};

interface RecordingsPage {
  recordingMessages: RecordingMessage[];
  total: number;
  isLoading: boolean;
}

export const getRecordingMessages = createAction<RecordingsPage>('GET_RECORDING_MESSAGES');
export const setIsLoadingRecordingMessage = createAction<boolean>('SET_IS_LOADING_RECORDING_MESSAGES');
export const setIsCreatingNewRecordingMessage = createAction<boolean>('SET_IS_CREATING_NEW_RECORDING_MESSAGE');
export const expandRecordingMessageRowAction = createAction<number | null>('EXPAND_RECORDING_MESSAGE_ROW');
export const sortRecordingMessages = createAction<SortConfiguration>('SORT_RECORDING_MESSAGES_TABLE');
export const activeRecordingMessagesPageUpdated = createAction<number>('UPDATE_ACTIVE_PAGE_RECORDING_MESSAGES');
export const changeRecordingMessagesPageSize = createAction<number>('SET_RECORDING_MESSAGES_PAGE_SIZE');
export const setRecordingMessageSearchTerm = createAction<string>('SET_RECORDING_MESSAGES_SEARCH_TERM');
export const setSelectedRecordingMessages = createAction<{
  selectedIds: number[];
  selectAllType?: SelectAllType;
}>('SET_SELECTED_RECORDING_MESSAGES');

export const recordingMessageReducer = createReducer(initialState, builder => {
  builder.addCase(setIsLoadingRecordingMessage, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(getRecordingMessages, (state, action) => {
    state.recordingMessages = action.payload.recordingMessages;
    state.totalMessages = action.payload.total;
    state.isLoading = action.payload.isLoading;
  });

  builder.addCase(setIsCreatingNewRecordingMessage, (state, action) => {
    state.isCreatingNewRecordingMessage = action.payload;
  });

  builder.addCase(expandRecordingMessageRowAction, (state, action) => {
    state.expandedRecordingMessageId = action.payload;
  });

  builder.addCase(sortRecordingMessages, (state, action) => {
    state.sort = action.payload;
  });

  builder.addCase(activeRecordingMessagesPageUpdated, (state, action) => {
    state.pageable = { ...state.pageable, skip: action.payload };
  });

  builder.addCase(changeRecordingMessagesPageSize, (state, action) => {
    state.pageable = { ...state.pageable, limit: action.payload };
  });

  builder.addCase(setRecordingMessageSearchTerm, (state, action) => {
    state.pageFilter = { ...state.pageFilter, searchTerm: action.payload };
  });

  builder.addCase(setSelectedRecordingMessages, (state, action) => {
    state.selectedRecordingMessages = action.payload.selectedIds;
    state.selectAllType = action.payload.selectAllType ? action.payload.selectAllType : null;
  });
});
